export function substitute(str, ...rest) {
    if (str == null) {
        return '';
    }
    // Replace all of the parameters in the msg string.
    let args;
    if (rest.length === 1) {
        if (Array.isArray(rest[0])) {
            // eslint-disable-next-line prefer-destructuring
            args = rest[0];
        }
        else if (typeof rest[0] === 'object') {
            // eslint-disable-next-line prefer-destructuring
            args = rest[0];
        }
    }
    else {
        args = rest;
    }
    if (args) {
        if (Array.isArray(args)) {
            args.forEach((value, index) => {
                str = str.replace(new RegExp('\\{' + index + '\\}', 'g'), value);
            });
        }
        else {
            Object.keys(args).forEach(i => {
                str = str.replace(new RegExp('\\{' + i + '\\}', 'g'), args[i]);
            });
        }
    }
    return str;
}
export function matchAll(str, re, cb) {
    const hasMatchAll = typeof str.matchAll === 'function';
    if (hasMatchAll) {
        const paramsMatch = str.matchAll(re);
        // eslint-disable-next-line no-restricted-syntax
        for (const paramMatch of paramsMatch) {
            cb(paramMatch);
        }
    }
    else {
        let match;
        // eslint-disable-next-line no-cond-assign
        while ((match = re.exec(str)) != null) {
            cb(match);
        }
    }
}
export function slugify(value) {
    if (!value || !value.length) {
        return '';
    }
    return value
        .replace(/\s+/gi, '-')
        .replace(/[^a-zA-Z0-9-]/gi, '')
        .toLowerCase();
}
